/* §3.6 dummy seeded forward rules. Keyed by merchant id. */
export const DUMMY_RULES_BY_MERCHANT = {
  m1: [
    {
      id: 1,
      name: 'Light items, prepaid — SDD + NDD + Surface cascade',
      weightFrom: 0,
      weightTo: 2,
      zones: ['LOCAL', 'REGIONAL', 'METROS'],
      payment: ['PREPAID'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['SDD_FWD_REG', 'INTERCITY_NDD_REG', 'FWD_SURFACE_REG'],
      priorityType: 'margin',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
    {
      id: 2,
      name: 'Heavy COD, Rest of India',
      weightFrom: 2,
      weightTo: 10,
      zones: ['ROI', 'SPECIAL'],
      payment: ['COD'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode', 'Item Units'],
      condValues: { 'Item Units': '1-5' },
      load: 'Regular',
      serviceTypes: ['INTERCITY_NDD_REG', 'FWD_AIR_REG', 'FWD_SURFACE_REG'],
      priorityType: 'custom',
      customOrder: ['Ekart', 'Delhivery SURFACE', 'DTDC_SURFACE', 'XpressBees'],
      disabled: false,
      _dead: false,
    },
    {
      id: 3,
      name: 'Bulk / Large shipments',
      weightFrom: 10,
      weightTo: 40,
      zones: ['LOCAL', 'REGIONAL', 'METROS', 'ROI', 'SPECIAL'],
      payment: ['PREPAID', 'COD'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Large',
      serviceTypes: ['FWD_SURFACE_LARGE', 'INTERCITY_NDD_LARGE'],
      priorityType: 'cost',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
  ],
  m3: [
    {
      id: 1,
      name: 'Default Forward — Margin cascade',
      weightFrom: 0,
      weightTo: 20,
      zones: ['LOCAL', 'REGIONAL', 'METROS', 'ROI', 'SPECIAL'],
      payment: ['PREPAID', 'COD'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['SDD_FWD_REG', 'INTERCITY_NDD_REG', 'FWD_SURFACE_REG'],
      priorityType: 'margin',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
    {
      id: 2,
      name: 'Same-day metros, prepaid',
      weightFrom: 0,
      weightTo: 2,
      zones: ['LOCAL', 'METROS'],
      payment: ['PREPAID'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['SDD_FWD_REG', 'SC_NDD_FWD_REG'],
      priorityType: 'cost',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
  ],
  m5: [
    {
      id: 1,
      name: 'Metro SDD — prepaid, light',
      weightFrom: 0,
      weightTo: 1,
      zones: ['LOCAL', 'METROS'],
      payment: ['PREPAID'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['SDD_FWD_REG', 'SC_NDD_FWD_REG'],
      priorityType: 'margin',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
    {
      id: 2,
      name: 'Within-state NDD cascade',
      weightFrom: 0,
      weightTo: 5,
      zones: ['REGIONAL', 'METROS'],
      payment: ['PREPAID', 'COD'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['INTERCITY_NDD_REG', 'FWD_SURFACE_REG'],
      priorityType: 'custom',
      customOrder: ['Delhivery SURFACE', 'XpressBees', 'Ekart'],
      disabled: false,
      _dead: false,
    },
    {
      id: 3,
      name: 'Rest of India — surface, cost-first',
      weightFrom: 0,
      weightTo: 10,
      zones: ['ROI', 'SPECIAL'],
      payment: ['PREPAID', 'COD'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['FWD_SURFACE_REG', 'FWD_AIR_REG'],
      priorityType: 'cost',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
    {
      id: 4,
      name: 'Heavy / Large — all zones',
      weightFrom: 10,
      weightTo: 40,
      zones: ['LOCAL', 'REGIONAL', 'METROS', 'ROI', 'SPECIAL'],
      payment: ['PREPAID', 'COD'],
      activeConds: ['Weight Range', 'Zone', 'Payment Mode'],
      condValues: {},
      load: 'Large',
      serviceTypes: ['FWD_SURFACE_LARGE', 'INTERCITY_NDD_LARGE'],
      priorityType: 'margin',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
  ],
};

export const DUMMY_REVERSE_RULES_BY_MERCHANT = {
  m1: [
    {
      id: 1,
      name: 'Reverse — Non-QC default',
      weightFrom: 0,
      weightTo: 10,
      zones: ['LOCAL', 'REGIONAL', 'METROS', 'ROI'],
      qcModes: ['NOQC'],
      activeConds: ['Weight Range', 'Zone', 'QC Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['REV_REG_NOQC'],
      priorityType: 'cost',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
    {
      id: 2,
      name: 'Reverse — With QC',
      weightFrom: 0,
      weightTo: 5,
      zones: ['LOCAL', 'REGIONAL', 'METROS'],
      qcModes: ['QC'],
      activeConds: ['Weight Range', 'Zone', 'QC Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['REV_REG_QC'],
      priorityType: 'cost',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
  ],
  m5: [
    {
      id: 1,
      name: 'Reverse — Non-QC (metros + RoI)',
      weightFrom: 0,
      weightTo: 10,
      zones: ['LOCAL', 'METROS', 'ROI'],
      qcModes: ['NOQC'],
      activeConds: ['Weight Range', 'Zone', 'QC Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['REV_REG_NOQC'],
      priorityType: 'cost',
      customOrder: [],
      disabled: false,
      _dead: false,
    },
    {
      id: 2,
      name: 'Reverse — With QC (metros)',
      weightFrom: 0,
      weightTo: 5,
      zones: ['LOCAL', 'METROS'],
      qcModes: ['QC'],
      activeConds: ['Weight Range', 'Zone', 'QC Mode'],
      condValues: {},
      load: 'Regular',
      serviceTypes: ['REV_REG_QC'],
      priorityType: 'custom',
      customOrder: ['XpressBees_Reverse_750', 'Shadowfax_Reverse_750'],
      disabled: false,
      _dead: false,
    },
  ],
};
